import { createContext } from 'react';
/**
 * Instance of the Member Context component for providing to children and for children to consume.
 */
export const MemberContextInstance = createContext({ member: undefined });
